// Copyright (c) 2022 by Move Closer

export enum Direction {
  Horizontal = 'horizontal',
  Vertical = 'vertical'
}
